import { Box, Chip, Grid } from '@material-ui/core';
import { Button, MultiSelectField, StandardDialog, TextField } from '@roc/ui';
import { store } from 'apps/client-portal-public/src/app/stores/store';
import { AppraisalDetailsV2Store } from 'libs/feature-documents/src/documents/stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import {
  AmountField,
  ReasonField,
  SelectOrdersField,
  SelectPropertiesField,
} from '../appraisalDetailsV2Fields';

export const ValuationReorderDialog = observer(
  ({
    store,
    open,
    onClose,
  }: {
    store: AppraisalDetailsV2Store;
    open: boolean;
    onClose: () => void;
  }) => {
    const formStore = store.appraisalActionsStore.appraisalActionsFormStore;
    const selectedPropertyIds = formStore.form.fields.propertyIds.value;
    const orders = selectedPropertyIds
      .map(id => store.appraisalActionsStore.ordersByProperyId[id] || [])
      .flat();

    useEffect(() => {
      if (open) {
        store.appraisalActionsStore.reset();
        store.appraisalActionsStore.fetchPropertyValuations();
      }
    }, [open]);

    const dialogContent = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SelectPropertiesField
            properties={store.properties}
            fieldName="propertyIds"
            formStore={formStore}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectOrdersField
            valuations={orders}
            fieldName="clientValuationReferenceIds"
            formStore={formStore}
          />
        </Grid>
        <Grid item xs={12}>
          <ReasonField fieldName="reason" formStore={formStore} />
        </Grid>
        <Grid item xs={12}>
          <AmountField fieldName="amount" formStore={formStore} />
        </Grid>
      </Grid>
    );

    const dialogActions = (
      <>
        <Button
          testId="closeButton"
          variant="outlined"
          color="primary"
          onClick={onClose}
          style={{ marginRight: 8 }}
        >
          CLOSE
        </Button>
        <Button
          testId="submitButton"
          color="primary"
          variant="contained"
          onClick={() => store.appraisalActionsStore.valuationReorder()}
        >
          SUBMIT
        </Button>
      </>
    );

    return (
      <StandardDialog
        open={open}
        maxWidth="sm"
        title="Valuation Reorder"
        handleClose={onClose}
        dialogContent={dialogContent}
        dialogActions={dialogActions}
      />
    );
  }
);
